// The whole background pipeline, ordered by value-per-byte: data first, the
// offline page second, thumbnails third, full-size images last.
import { imageUrlsOf, type OfflineSnapshot } from "./snapshot";
import { saveSnapshot, setMeta } from "./db";
import { pruneImages, syncImages } from "./image-sync";
import { syncOfflineShell } from "./shell-sync";

export async function runOfflineSync(userId: string): Promise<void> {
  try {
    const res = await fetch("/api/offline/library", {
      credentials: "same-origin",
      cache: "no-store",
    });
    if (!res.ok) return;
    const snapshot = (await res.json()) as OfflineSnapshot;
    await saveSnapshot(userId, snapshot);

    await syncOfflineShell();

    const { thumbs, fulls } = imageUrlsOf(snapshot);
    await pruneImages(new Set([...thumbs, ...fulls]));
    const thumbResult = await syncImages(thumbs);
    const fullResult = thumbResult.quotaExceeded
      ? { quotaExceeded: true }
      : await syncImages(fulls);

    await setMeta({
      userId,
      lastSyncedAt: new Date().toISOString(),
      quotaExceeded: thumbResult.quotaExceeded || fullResult.quotaExceeded,
    });
  } catch {
    // Silent by design: the offline copy just goes stale until the next visit.
  }
}
